import { format, differenceInDays } from 'date-fns'
import { STATUSES } from 'constants/data.statuses'

export const getStatus = (event) => {
  if (!event) {
    return STATUSES.NOT_AVAILABLE
  }

  if (event.resolved) {
    return 'Finished'
  }

  if (
    event.startTime &&
    differenceInDays(new Date(event.startTime), new Date()) < 0
  ) {
    return 'In Progress'
  }

  return 'Not Started'
}

export const getLocation = (event) => {
  if (!event) {
    return STATUSES.NOT_AVAILABLE
  }

  if (event.city && event.jurisdiction?.name) {
    return `${event.city}, ${event.jurisdiction.name}`
  }

  return event.city || event.jurisdiction?.name
}

export const getFormattedDate = (event, dateProp) => {
  if (!event) {
    return STATUSES.NOT_AVAILABLE
  }

  return format(new Date(event[dateProp]), 'MMMM dd, y')
}
